import { render, staticRenderFns } from "./PhysicalAssessmentCSV.vue?vue&type=template&id=6ed086ec&scoped=true&"
import script from "./PhysicalAssessmentCSV.vue?vue&type=script&lang=ts&"
export * from "./PhysicalAssessmentCSV.vue?vue&type=script&lang=ts&"
import style0 from "./PhysicalAssessmentCSV.vue?vue&type=style&index=0&id=6ed086ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed086ec",
  null
  
)

export default component.exports